import React from "react";

const OrganizationLicense = () => {
    return <>OrganizationLicense...</>;
};

export default OrganizationLicense;
